<template>
  <div>
    <div
      style="
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <m-page-header :title="$t(`apply.title.applicationInfo`)"></m-page-header>
    </div>

    <m-form ref="form">
      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="surname"
            is-form-item
            :maxLength="50"
            :disabled="form.isReissue"
            v-model="form.surname"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="this.$t(`apply.title.surname`)"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="givenName"
            is-form-item
            :maxLength="50"
            :disabled="form.isReissue"
            v-model="form.givenName"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="this.$t(`apply.title.givenName`)"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-select
            :disabled="form.isReissue"
            style="width: 100%"
            is-form-item
            v-model="form.idCardType"
            :placeholder="$t('Common.message.pleaseSel')"
            :options="certificateType"
            :label="$t(`apply.title.certificateType`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
            ]"
            ref="idCardType"
          ></m-select>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            :disabled="form.isReissue"
            is-form-item
            :maxLength="50"
            v-model="form.cardNo"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="$t(`apply.title.IDNumber`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
              {
                pattern: /^[a-zA-Z0-9\s]*$/,
                message: $t('Common.message.formatError'),
              },
            ]"
            ref="idCard"
          ></m-input>
        </m-col>
      </m-row>

      <m-page-header :title="$t(`apply.title.companyInfo`)"></m-page-header>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="companyName"
            :disabled="form.isReissue"
            is-form-item
            :maxLength="200"
            :placeholder="$t('Common.message.pleaseEnter')"
            v-model="form.companyName"
            :label="this.$t(`apply.title.companyName`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-select
            :disabled="form.isReissue"
            style="width: 100%"
            is-form-item
            v-model="form.entityType"
            :placeholder="$t('Common.message.pleaseSel')"
            :options="getCompanyCertificateType"
            :label="$t(`apply.title.companyCertificateType`)"
            :rules="[
              {
                required: this.$route.params.typeName === 'business' ? false :true,
                message: this.$route.params.typeName === 'business' ? '' : $t(`Common.message.required`),
              },
            ]"
            ref="entityType"
          ></m-select>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            :disabled="form.isReissue"
            is-form-item
            :maxLength="50"
            v-model="form.companyCode"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="$t(`apply.title.companyIDNumber`)"
            :rules="[
              {
                required: this.$route.params.typeName === 'business' ? false :true,
                message: this.$route.params.typeName === 'business' ? '' : $t(`Common.message.required`),
              },
              {
                pattern: /^[a-zA-Z0-9\s]*$/,
                message: $t('Common.message.formatError'),
              },
            ]"
            ref="companyCode"
          ></m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="fsaNo"
            is-form-item
            :maxLength="50"
            :placeholder="$t('Common.message.pleaseEnter')"
            v-model="form.taxNo"
            :label="this.$t(`apply.title.taxNum`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="address"
            is-form-item
            :maxLength="200"
            v-model="form.address"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="$t(`apply.title.address`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
            ]"
          ></m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="contactInfo"
            :maxLength="100"
            is-form-item
            v-model="form.contact"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="$t(`apply.title.contactInfo`)"
          ></m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="21">
          <m-input
            ref="mobileNum"
            isFormItem
            :maxLength="form.areaCode === '+86' ? 11 : 8"
            :label="$t('apply.title.contactNumber1')"
            v-model.trim="form.mobile"
            :placeholder="$t('Common.message.pleaseEnter')"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
              {
                pattern: phoneFormat(form.areaCode),
                message: this.$t('Common.title.formatError'),
              },
              {
                validator: (rule, v) =>
                  (!form.mobile && !form.areaCode) ||
                  (!!form.mobile && !!form.areaCode),
                isRequired: true,
              },
            ]"
          >
            <template v-slot:contentPrefix>
              <m-select
                layout="vertical"
                option-filter-prop="children"
                v-model="form.areaCode"
                :placeholder="$t('Common.message.pleaseSel')"
                :options="areaCodeOptions"
                :dropdownMatchSelectWidth="false"
                :class="
                  isMobile ? 'combination__field_mobile' : 'combination__field'
                "
                @change="(form.areaCode = $event), handleValidate"
              />
            </template>
          </m-input>
        </m-col>
      </m-row>
      <CaptchaText v-model="form.captcha"></CaptchaText>
    </m-form>
    <TipDialog
      :visible.sync="dialog"
      :documentTypes="form.documentTypes"
      @ok="dialog = false"
      @handleCancel="handleCancel"
      @cancel="dialog = false"
    />
  </div>
</template>
<script>
import {
  getSpan,
  is_mobile,
  ApiLanguage,
  phoneFormat,
  formatAreaCode,
} from 'govmo-common/src/utils/utils';
import {
  getAreaCodeOptions,
  getCertificateType,
  getCompanyCertificateType,
} from 'govmo-common/src/utils/options';
import CaptchaText from '@/components/CaptchaText.vue';
import { addressMixin } from 'common/components/Address/web/address';
import TipDialog from '@/components/TipDialog.vue';
import { FileAPI, ApplyAPI } from '@/api';
// import { convertToBlob, blobToFiles } from 'govmo-common/src/utils/file';

export default {
  mixins: [addressMixin],
  components: {
    CaptchaText,
    TipDialog,
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      certificateType: getCertificateType(),
      getCompanyCertificateType: getCompanyCertificateType(),
      areaCodeOptions: getAreaCodeOptions(),
      isMobile: is_mobile(),
      form: { areaCode: '+853' },
      dialog:
        sessionStorage.getItem(`${this.$route.params.typeName}RemindAgain`) ===
        'true'
          ? false
          : true,
    };
  },
  methods: {
    getSpan,
    phoneFormat,
    handleCancel(checked) {
      this.dialog = false;
      sessionStorage.setItem(
        `${this.$route.params.typeName}RemindAgain`,
        checked
      );
    },
    onPrevious() {
      this.$emit('previous');
    },
    async onNext() {
      try {
        if (!(await this.$refs.form.validateFields())) return;
        this.$set(
          this.form,
          'applicationType',
          this.form.isReissue ? 'SUPPLEMENT' : 'FIRST'
        );
        this.$set(this.form, 'applicationChannel', 'INTERNET');
        this.$set(
          this.form,
          'companyType',
          this.$route.params.typeName === 'business' ? 'PERSONAL' : 'COMPANY'
        ); /*公司类型 PERSONAL-獨資商人 COMPANY-公司*/
        // this.$set(this.form, 'address', this.form.addressData?.fullAddress);
        this.$set(this.form, 'name', this.form.surname + this.form.givenName);
        this.$set(this.form, 'language', ApiLanguage());
        this.$set(this.form, 'status', 'SUBMITTED');
        this.getApplyBasic();
        // this.$emit('next', { ...this.formData, ...this.form });
      } catch (error) {
        return;
      }
    },
    async getApplyBasic() {
      try {
        this.$showLoading();
        let apiAreaCode = this.form.areaCode?.replace(/\+/g, '');
        let value = { ...this.form, areaCode: apiAreaCode };
        let basicData = await ApplyAPI.ApplyBasic(value, this.form.captcha);
        this.$set(this.form, 'applicationNo', basicData.applicationNo);
        this.$emit('next', this.form);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    async getDocumentType() {
      try {
        this.$showLoading();
        let documentData = await FileAPI.getDocumentType(
          this.form.isReissue ? 'SUPPLEMENT' : 'FIRST', //FIRST(首次)、RFC(變更)、SUPPLEMENT(補交)
          this.$route.params.typeName === 'business' ? 'PERSONAL' : 'COMPANY'
        );
        documentData.forEach((file) => {
          let fileList = [];
          this.form.documentEcho?.forEach((listFile, number) => {
            if (String(file.index) === listFile.typeIndex) {
              if (listFile.mailing) {
                file.mailingType = 'update1';
              } else {
                file.mailingType = 'update2';
                fileList.push({
                  ...listFile,
                  name: `${listFile.originalFileName}.${listFile.suffix}`,
                  uid: String(file.index) + String(number),
                  fileId: listFile.id,
                });
              }
            }
            file.fileList = fileList;
          });

          this.form.documentTypes?.forEach((listFile) => {
            if (file.index === listFile.index && listFile.fileList) {
              file.fileList = listFile.fileList;
            }
          });
        });
        this.$set(this.form, 'documentTypes', documentData);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    async handleValidate() {
      this.$refs.name.handleValidate();
      this.$refs.fsaNo.handleValidate();
      this.$refs.contactInfo.handleValidate();
      this.$refs.idCardType.handleValidate();
      this.$refs.idCard.handleValidate();
      this.$refs.address.handleValidate();
      this.$refs.mobileNum.handleValidate();
    },
  },
  async created() {
    console.log(
      '====1',
      sessionStorage.getItem(`${this.$route.params.typeName}RemindAgain`)
    );
    // 補交
    if (this.$route.params.isReissue) {
      this.form = {
        ...this.$route.params,
        areaCode: formatAreaCode(this.$route.params.areaCode),
        openDateStr: this.$route.params.openDate,
        otp: null,
      };
    } else {
      this.form = this.form ? this.form : { ...this.formData };
    }
    this.getDocumentType();
  },
};
</script>
<style lang="scss" scoped>
.combination__field {
  width: 20%;
}
.combination__field_mobile {
  width: 43%;
}
::v-deep .m-form-item-wrapper .m-form-item-main {
  align-items: center;
}
</style>

